type ISettings = {
  serverAddress: string
  serverPort: number
  language: string
  languages: Array<Language>
}

type Language = {
  name: string
  code: string
}

const Settings: ISettings = {
  serverAddress: process.env.SITE_URL,
  serverPort: 3000,
  language: 'pl',
  languages: [
    { name: 'Polish', code: 'pl' },
    { name: 'English', code: 'en' },
    { name: 'Spanish', code: 'es' },
    { name: 'Ukrainian', code: 'ua' },
    { name: 'Lithuanian', code: 'lt' },
    { name: 'Russian', code: 'ru' },
  ],
}

export default Settings
